'use strict';
import { fh_add, fh_mul, fh_polygon } from '@acenv/fh-3d-viewer';
import { cn_building } from '../../model/cn_building';
import { cn_nomenclature, export_layers_and_zpsos } from '../cn_nomenclature';
import { cn_plugin_option } from '../cn_plugin_option';
import { SPACE_EXTERIOR_LABEL } from '../../model/cn_model_constants';
//***********************************************************************************
//***********************************************************************************
//**** Build nomenclatures
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
/**
 * Buils slab nomenclatures for the building
 * @param {cn_building} building
 * @returns {cn_nomenclature[]}
 */
export function cn_nomenclature_slabs(building) {
    const output = [];

    output.push(new cn_nomenclature('ID').withVirtual(true));
    output.push(new cn_nomenclature('Nom'));
    output.push(new cn_nomenclature('Type'));
    output.push(new cn_nomenclature('Niveau'));
    output.push(new cn_nomenclature('Index niveau').withVisibility(false));
    output.push(new cn_nomenclature('Espace inf'));
    output.push(new cn_nomenclature('Espace sup'));
    output.push(new cn_nomenclature('Structure'));
    output.push(new cn_nomenclature('Isolation'));
    output.push(new cn_nomenclature('Largeur').withNumberDefinition('m', 2));
    output.push(new cn_nomenclature('Longueur').withNumberDefinition('m', 2));
    output.push(new cn_nomenclature('Epaisseur').withNumberDefinition('m', 2));
    output.push(new cn_nomenclature('Surface').withNumberDefinition('m²', 2));
    output.push(new cn_nomenclature('Volume').withNumberDefinition('m²', 2));
    output.push(new cn_nomenclature('U').withNumberDefinition('W/m².K', 3));
    output.push(new cn_nomenclature('Calques').withVisibility(false));
    if (cn_plugin_option.zpsos) {
        output.push(new cn_nomenclature('ZPSOs').withVisibility(false));
    }

    building.storeys.length && building.storeys.forEach((storey, index) => {
        const storey_below = (index > 0) ? building.storeys[index - 1] : null;
        storey.slabs.length && [...storey.slabs, ...storey.upper_slabs].forEach((slab) => {

            const slab_type = slab.slab_type;
            let k = 0;
            //*** ID */
            output[k].values.push(slab.create_id_for_bbp(storey));
            k++

            //*** name */
            output[k].values.push(slab_type.get_label());
            k++

            //*** Type */
            output[k].values.push(slab_type.get_label());
            k++

            //*** storey */
            output[k].values.push(storey.get_storey_name());
            k++
            output[k].values.push(storey.get_storey_index_in_building());
            k++

            //*** Space 1 */
            output[k].values.push(get_slab_space_name(slab.spaces[0], storey_below));
            k++

            //*** Space 2 */
            output[k].values.push(get_slab_space_name(slab.spaces[1], storey));
            k++

            //*** Structure  */
            output[k].values.push(slab_type.get_structure_label());
            k++

            //*** Insulation  */
            output[k].values.push(slab_type.get_insulation_label());
            k++

            //*** slab geometry */
            const slab_metrics = slab.get_metrics();

            //*** Width  */
            output[k].values.push(slab_metrics.width);
            k++

            //*** length  */
            output[k].values.push(slab_metrics.length);
            k++

            //*** thickness  */
            output[k].values.push(slab_metrics.thickness);
            k++

            //*** full area  */
            output[k].values.push(slab_metrics.area);
            k++

            //*** volume  */
            output[k].values.push(slab_metrics.volume);
            k++

            //*** U  */
            output[k].values.push(slab_type.get_U());
            k++

            //*** layers & zpsos  */
            k = export_layers_and_zpsos(storey, slab, slab_type, output, k);
        });
    });
    return output;
}

function get_slab_space_name(space, storey) {
    if (space && !space.outside) return space.get_name(storey);
    return SPACE_EXTERIOR_LABEL;
}
